import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import TextareaAutosize from 'react-autosize-textarea';
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { forwardRef } from '@wordpress/element';
/**
 * Internal dependencies
 */

import EditableText from '../editable-text';
/**
 * @see https://github.com/WordPress/gutenberg/blob/HEAD/packages/block-editor/src/components/plain-text/README.md
 */

const PlainText = forwardRef((_ref, ref) => {
  let {
    __experimentalVersion,
    ...props
  } = _ref;

  if (__experimentalVersion === 2) {
    return createElement(EditableText, _extends({
      ref: ref
    }, props));
  }

  const {
    className,
    onChange,
    ...remainingProps
  } = props;
  return createElement(TextareaAutosize, _extends({
    ref: ref,
    className: classnames('block-editor-plain-text', className),
    onChange: event => onChange(event.target.value)
  }, remainingProps));
});
export default PlainText;
//# sourceMappingURL=index.js.map